import { NzMessageService } from 'ng-zorro-antd/message';
import { MediaService } from './../../media.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { WebcamImage, WebcamInitError } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-camera',
  templateUrl: './camera.component.html',
  styleUrls: ['./camera.component.less'],
})
export class CameraComponent implements OnInit {
  @Output() fileUploaded: EventEmitter<string> = new EventEmitter();
  isLoading = false;

  public errors: WebcamInitError[] = [];

  // latest snapshot
  public webcamImage: WebcamImage = null;

  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean | string> = new Subject<
    boolean | string
  >();

  constructor(private mediaService: MediaService, private messageService: NzMessageService) {}
  public ngOnInit(): void {}

  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
  }

  public handleImage(webcamImage: WebcamImage): void {
    console.log('received webcam image', webcamImage);
    this.webcamImage = webcamImage;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  submitAndUpload() {
    this.mediaService
      .submitData(this.webcamImage.imageAsDataUrl, 'snapshot')
      .subscribe((e: any) => {
        if (e.Has_Error) {
          this.messageService.error(e.Error_Message);
        }
        else {
          this.fileUploaded.emit(e.Resault_Value);
        }

        this.isLoading = false;
      });
  }
}
